import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist'

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'slfi-questionnaire',
  storage: localStorage
})

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],

  state: {
    loggedIn: false,
    token: '',
    refreshToken: '',
    isFatchToken: false,
  },
  mutations: {
    SET_LoggedIn: (state: any, data) => {
      state.loggedIn = data
    },
    SET_Token: (state : any, data) => {
      state.token = data;
    },
    SET_RefreshToken: (state: any, data) => {
      state.refreshToken = data
    },
    SET_IsFatchToken: (state: any, data) => {
      state.isFatchToken = data
    },
  },
  getters: {
    getLoggedIn: (state) => () => {
      return state.loggedIn
    },
    getToken: (state) => () => {
      return state.token;
    },
    getRefreshToken: (state) => () => {
      return state.refreshToken
    },
    getIsFatchToken: (state) => () => {
        return state.isFatchToken
    },
  },
  actions: {

  },
});
